import axios from 'axios';
import React, { createContext, useState, useEffect } from 'react';
export const CartContext = createContext();

export const CartProvider = ({ children }) => {



  const [products, setProducts] = useState([]);
  useEffect(() => {
    const fetchProducts = async () => {
      try {
        const response = await fetch('https://api.glocart.in/pages/api/products/get');
        const data = await response.json();
        setProducts(data.products || []);
      } catch (err) {
        console.error('Error fetching product:', err);
      }
    };

    fetchProducts();
  }, []);




  const [cartItems, setCartItems] = useState([]);
  useEffect(() => {
    const storedCart = JSON.parse(sessionStorage.getItem('cartItems'));
    if (storedCart) {
      setCartItems(storedCart);
    }
  }, []);
  const saveCartToLocalStorage = (updatedCart) => {
    sessionStorage.setItem('cartItems', JSON.stringify(updatedCart));
  };

  useEffect(() => {
    const user = JSON.parse(sessionStorage.getItem('userData'));
    if (user) {
      sessionStorage.removeItem('tempCart');
      fetchCart();
    }
  }, []);


  const addToCart = async (product, quantityChange) => {

    console.log('product, quantityChange',product, quantityChange)

    const user = JSON.parse(sessionStorage.getItem('userData'));
    console.log('this is user',user)
    if (!user) {
      let tempCart = JSON.parse(sessionStorage.getItem('tempCart')) || [];

      const productId = product.productId || product.id;
      console.log('productId',productId)
      const variantId = product.variantId || (product.variant && product.variant.id);
      console.log('variantId',variantId)
      const existingIndex = tempCart.findIndex(item =>
        item.productId === productId && item.variantId === variantId
      );

      if (existingIndex !== -1) {
        tempCart[existingIndex].quantity += quantityChange;
      } else {
        tempCart.push({
          productId,
          variantId,
          name: product.name,
          image: product.image,
          price: product.price,
          originalPrice: product.originalPrice,
          quantity: quantityChange,
          quantityLimit: product.variant?.quantity || 1,
        });
      }

      sessionStorage.setItem('tempCart', JSON.stringify(tempCart));
      setCartItems(tempCart);
      alert(`${product.name} added to your cart (temporarily). Please login to save.`);
      return;
    }
    try {
      const existingItem = cartItems.find(
        item => item.productId === product.productId && item.variantId === product.variantId
      );
      if (existingItem) {
        const newQuantity = existingItem.quantity + quantityChange;
        await axios.put('https://api.glocart.in/pages/api/cart', {
          user_id: user.id,
          product_id: product.productId,
          variant_id: product.variantId,
          quantity: newQuantity
        });
      } else {
        await axios.post('https://api.glocart.in/pages/api/api/add-to-cart', {
          userId: user.id,
          productId: product.productId,
          variantId: product.variantId,
          quantity: quantityChange,
          customerType: user.business_type,
        });
      }
      fetchCart();
    } catch (error) {
      console.error('Error adding to cart:', error);
    }
  };

  const fetchCart = async () => {
    const user = JSON.parse(sessionStorage.getItem('userData'));
    if (!user) return;
    const userId = user.id;
    try {
      const response = await axios.get(`https://api.glocart.in/pages/api/cart/${userId}`);
      setCartItems(response.data);
    } catch (error) {
      console.error('Failed to fetch cart:', error);
    }
  };

  useEffect(() => {
    fetchCart();
  }, []);


  const removeFromCart = async (productId, variantId) => {
    const user = JSON.parse(sessionStorage.getItem('userData'));
    if (!user) {
      let tempCart = JSON.parse(sessionStorage.getItem('tempCart')) || [];
      tempCart = tempCart.filter(item => {
        const idMatch = (item.productId || item.id) !== productId;
        const variantMatch = item.variantId !== variantId;
        return idMatch || variantMatch;
      });
      sessionStorage.setItem('tempCart', JSON.stringify(tempCart));
      setCartItems(tempCart);
      alert('Item removed from temporary cart.');
      return;
    }
    try {
      await axios.delete(`https://api.glocart.in/pages/api/cart/${user.id}/${productId}/${variantId}`);
      alert("Item removed from cart");
      setCartItems(prevItems =>
        prevItems.filter(item => !((item.productId === productId || item.id === productId) && item.variantId === variantId))
      );
      sessionStorage.removeItem('tempCart');
      sessionStorage.removeItem('cartItems');
      fetchCart();
    } catch (error) {
      console.error('Error removing from cart:', error);
    }
  };


const increaseQuantity = (productId, variantId) => {
  const user = JSON.parse(sessionStorage.getItem('userData'));

  setCartItems(prevItems => {
    const updatedCart = prevItems.map(item => {
      if (
        (item.productId === productId || item.id === productId) &&
        (item.variantId === variantId || !variantId)
      ) {
        // 1. Try to find from full product list
        const product = products.find(p => p.id === productId);
        const variant = product?.variants?.find(v => v.id === variantId);

        // 2. Fallback to item.stockQty if variant not found
        const stockLimit = variant?.stock ?? item.stockQty ?? Infinity;

        const currentQuantity = item.quantity;
        if (currentQuantity >= stockLimit) {
          alert(`Only ${stockLimit} units in stock.`);
          return item;
        }

        const updatedQuantity = currentQuantity + 1;

        // 3. Update server if logged in
        if (user) {
          axios.put('https://api.glocart.in/pages/api/cart', {
            user_id: user.id,
            product_id: productId,
            variant_id: variantId,
            quantity: updatedQuantity,
          }).catch(err => console.error("Failed to update cart:", err));
        }

        return { ...item, quantity: updatedQuantity };
      }
      return item;
    });

    saveCartToLocalStorage(updatedCart);
    return updatedCart;
  });
};




  const decreaseQuantity = (productId, variantId) => {
    const user = JSON.parse(sessionStorage.getItem('userData'));

    setCartItems(prevItems => {
      const updatedCart = prevItems.map(item => {
        if (
          (item.productId === productId || item.id === productId) &&
          (item.variantId === variantId || !variantId) &&
          item.quantity > 1
        ) {
          const updatedQuantity = item.quantity - 1;

          if (user) {
            axios.put('https://api.glocart.in/pages/api/cart', {
              user_id: user.id,
              product_id: item.productId || item.id,
              variant_id: item.variantId,
              quantity: updatedQuantity,
            }).catch(err => console.error("Failed to update cart:", err));
          }

          return { ...item, quantity: updatedQuantity };
        }
        return item;
      });
      saveCartToLocalStorage(updatedCart);
      return updatedCart;
    });
  };




  return (
    <CartContext.Provider
      value={{
        cartItems,
        addToCart,
        setCartItems,
        removeFromCart,
        increaseQuantity,
        decreaseQuantity,
      }}
    >
      {children}
    </CartContext.Provider>
  );
};
